(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-catalog-browse"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  document.querySelectorAll('.mm-catalog-browse details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
});
document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mm-catalog-browse details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); }); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-catalog-controls"] && !Shopify.designMode) return;
  try {
    function mmInitializeFacets(){document.querySelectorAll('[data-mm-facets]:not([data-mm-ready])').forEach(el=>{el.dataset.mmReady='true';if(matchMedia('(max-width:989px)').matches)el.open=false;if(el.closest('[data-mm-collection-controls]')){const mmMobileViewport=matchMedia('(max-width:989px)');mmMobileViewport.addEventListener('change',event=>{el.open=!event.matches;});}});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mmInitializeFacets,{once:true});else mmInitializeFacets();
document.addEventListener('shopify:section:load',mmInitializeFacets);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-curated-collection-directory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-curated-directory')) customElements.define('mm-curated-directory', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    const search = this.querySelector('[data-mm-directory-search]');
    const input = search && search.querySelector('input');
    const status = this.querySelector('[data-mm-directory-status]');
    const empty = this.querySelector('[data-mm-directory-empty]');
    if (!search || !input || !status || !empty) return;
    const productSearch = empty.querySelector('[data-mm-directory-product-search]');
    const productSearchBase = productSearch && productSearch.getAttribute('href');
    this.ready = true;
    const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[-_]+/g, ' ').toLocaleLowerCase();
    const groups = [...this.querySelectorAll('[data-mm-directory-group]')];
    const entries = [...this.querySelectorAll('[data-mm-directory-item]')].map(node => ({node,text:normalize(node.textContent + ' ' + (node.dataset.mmDirectorySearchText || ''))}));
    const initialOpen = groups.map(group => group.open);
    const matchesWord = (text, word) => word.length <= 2 ? text.split(/[^\p{L}\p{N}]+/u).includes(word) : text.includes(word);
    const update = () => {
      const words = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let matches = 0;
      entries.forEach(({node,text}) => { node.hidden = !words.every(word => matchesWord(text, word)); if (!node.hidden) matches++; });
      groups.forEach((group,index) => {
        group.hidden = !group.querySelector('[data-mm-directory-item]:not([hidden])');
        group.open = words.length ? !group.hidden : initialOpen[index];
      });
      status.textContent = this.dataset.mmDirectoryMatchLabel.replace('__COUNT__', matches);
      empty.hidden = matches > 0;
      if (productSearch && productSearchBase) {
        const destination = new URL(productSearchBase, window.location.origin);
        const query = input.value.trim();
        if (query) destination.searchParams.set('q', query);
        else destination.searchParams.delete('q');
        destination.searchParams.set('type', 'product');
        productSearch.setAttribute('href', destination.pathname + destination.search);
      }
    };
    input.addEventListener('input', update);
    input.addEventListener('search', update);
    search.hidden = false;
    update();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-loose-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    document.querySelectorAll('[data-lc-filters]:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const details = form.closest('details');
      if (window.matchMedia('(max-width:750px)').matches) details.open = false;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const tags = Array.from(form.querySelectorAll('select[data-lc-tag]')).map(s => s.value).filter(Boolean);
        const url = new URL(form.dataset.base, location.origin);
        if (tags.length) url.pathname += '/' + tags.join('+');
        const current = new URL(location.href);
        ['sort_by','preview_theme_id','filter.v.price.gte','filter.v.price.lte'].forEach(k => {if(current.searchParams.has(k)) url.searchParams.set(k,current.searchParams.get(k));});
        form.querySelectorAll('[data-lc-price]').forEach(input=>{if(input.value!=='')url.searchParams.set(input.name,input.value);else url.searchParams.delete(input.name);});
        location.assign(url.href);
      });
    });
    document.querySelectorAll('.lc-sort:not([data-ready])').forEach(form=>{form.dataset.ready='true';form.querySelector('button').hidden=true;form.querySelector('select').addEventListener('change',()=>form.requestSubmit());});
    document.querySelectorAll('.lc-add-form:not([data-lc-ready])').forEach(form => {
      form.dataset.lcReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();event.stopImmediatePropagation();
        const button = form.querySelector('button');if(button.disabled)return;
        const label=button.textContent;button.disabled=true;
        const root=(window.Shopify?.routes?.root)||'/';
        const toast=document.querySelector('.lc-toast');
        const message=toast?.querySelector('[data-lc-message]');
        try {
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||result.message||document.querySelector('[data-lc-error]')?.dataset.lcError||'Unable to add this car.');
          if(message)message.textContent=(document.querySelector('[data-lc-added]')?.dataset.lcAdded||'Added to cart')+': '+button.dataset.title;
          if(toast)toast.hidden=false;
          try {
            const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
            if(response.ok){const cart=await response.json();document.querySelectorAll('[data-lc-cart-count]').forEach(e=>e.textContent=String(cart.item_count));document.querySelectorAll('[data-lc-shipping]').forEach(el=>{const remaining=Math.max(0,10000-cart.total_price);const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(remaining/100);el.querySelector('p').textContent=remaining>0?el.dataset.more.replace('__AMOUNT__',money):el.dataset.met;el.querySelector('progress').value=Math.min(10000,cart.total_price);});document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));}
          }catch(error){}
        }catch(error){if(message)message.textContent=error.message;if(toast)toast.hidden=false;}
        finally{button.disabled=false;button.textContent=label;}
      },true);
    });
    document.querySelectorAll('[data-lc-cart-link]:not([data-ready])').forEach(link=>{link.dataset.ready='true';link.addEventListener('click',event=>{event.stopPropagation();location.assign(link.href);});});
    document.querySelectorAll('[data-lc-dismiss]:not([data-ready])').forEach(button=>{button.dataset.ready='true';button.addEventListener('click',()=>button.closest('.lc-toast').hidden=true);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-product-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const states = new WeakMap();

  function updateProductDetails() {
    document.querySelectorAll('[data-mm-product-page-info]').forEach((info) => {
      let state = states.get(info);
      if (!state) {
        const root = info.closest('.mm-mobile-product[data-mm-product-root]');
        const gallery = root?.querySelector('.mm-product-layout > [data-mm-gallery]');
        const layout = gallery?.parentElement;
        const rows = Array.from(info.children).filter((row) => row.hasAttribute('data-mm-gallery-detail'));
        if (!gallery?.querySelector('.mm-product-gallery__featured') || !layout || !rows.length) return;

        const panel = document.createElement('div');
        panel.className = 'mm-product-gallery-details';
        const entries = rows.map((row) => {
          const anchor = document.createComment('MM product details original position');
          row.before(anchor);
          return {row, anchor};
        });
        const hostSection = info.closest('.mm-product-page-info-section');
        state = {gallery, layout, panel, entries, hostSection, isDesktop: false};
        states.set(info, state);
      }
      if (state.isDesktop === desktop.matches) return;

      const activeElement = document.activeElement;
      const restoreFocus = state.entries.some(({row}) => row.contains(activeElement));
      if (desktop.matches) {
        state.gallery.appendChild(state.panel);
        state.entries.forEach(({row}) => state.panel.appendChild(row));
        state.layout.classList.add('mm-product-layout--gallery-details');
        if (state.hostSection) state.hostSection.hidden = true;
      } else {
        state.entries.forEach(({row, anchor}) => anchor.after(row));
        state.panel.remove();
        state.layout.classList.remove('mm-product-layout--gallery-details');
        if (state.hostSection) state.hostSection.hidden = false;
      }
      state.isDesktop = desktop.matches;
      if (restoreFocus) activeElement.focus({preventScroll: true});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateProductDetails, {once: true});
  } else {
    updateProductDetails();
  }
  desktop.addEventListener('change', updateProductDetails);
  document.addEventListener('shopify:section:load', updateProductDetails);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-saved-products"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'mm-marketplace-saved-v1';
  const dialog = document.getElementById('mm-saved-products');
  if (!dialog) return;
  let items = [];
  const validItem = item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(item.url) && !item.url.includes('\\');
  const read = () => {
    try { const data = JSON.parse(localStorage.getItem(key) || '[]'); items = Array.isArray(data) ? data.filter(validItem).slice(0,100) : []; }
    catch { items = []; }
  };
  const persist = () => {
    try { localStorage.setItem(key,JSON.stringify(items)); }
    catch { dialog.querySelector('[data-mm-saved-note]').textContent = dialog.dataset.temporary; }
  };
  const sync = () => {
    document.querySelectorAll('[data-mm-save]').forEach(button => {
      const saved = items.some(item => item.id === button.dataset.productId);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.saveLabel);
    });
    document.querySelectorAll('[data-mm-saved-open]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-mm-saved-count]').forEach(count => { count.textContent = items.length ? ` (${items.length})` : ''; });
  };
  const render = () => {
    const list = dialog.querySelector('[data-mm-saved-list]');
    list.replaceChildren();
    if (!items.length) { const p = document.createElement('p'); p.textContent = dialog.dataset.empty; list.append(p); }
    items.forEach(item => {
      const row = document.createElement('div'); row.className = 'mm-saved__item';
      const img = document.createElement('img'); img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy';
      if (typeof item.image === 'string' && /^(?:https:)?\/\/(?:cdn\.shopify\.com|munclemikes\.com)\//.test(item.image)) img.src = item.image;
      else img.hidden = true;
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = dialog.dataset.remove;
      remove.addEventListener('click', () => { items = items.filter(other => other.id !== item.id); persist(); sync(); render(); dialog.querySelector('[data-mm-saved-close]').focus(); });
      row.append(img, link, remove); list.append(row);
    });
  };
  read(); sync();
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const button = target.closest('[data-mm-save]');
    if (button) {
      const id = button.dataset.productId;
      if (items.some(item => item.id === id)) items = items.filter(item => item.id !== id);
      else { items.unshift({id, url:button.dataset.productUrl, title:button.dataset.productTitle, image:button.dataset.productImage}); items = items.slice(0,100); }
      persist(); sync();
    }
    if (target.closest('[data-mm-saved-open]')) { render(); dialog.showModal(); }
    if (target.closest('[data-mm-saved-close]')) dialog.close();
  });
  window.addEventListener('storage', event => { if (event.key === key) { read(); sync(); if (dialog.open) render(); } });
  document.addEventListener('shopify:section:load', sync);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-wheel-shopping-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-wheel-shopping-filters')) {
    class MMWheelShoppingFilters extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this.ready || !this.isConnected) return;
        const sortStateKey = `mm-wheel-sort:${location.pathname}`;
        let pendingSort = null;
        try {
          pendingSort = JSON.parse(sessionStorage.getItem(sortStateKey) || 'null');
          sessionStorage.removeItem(sortStateKey);
        } catch (_) { /* Refinements still work when browser storage is unavailable. */ }
        const catalog = this.closest('[data-r32-catalog]');
        const grid = catalog && catalog.querySelector('[data-r32-product-grid]');
        const dataNode = this.querySelector('[data-mm-wheel-data]');
        const fallback = this.querySelector('[data-mm-wheel-fallback]');
        if (!grid || !dataNode || !fallback) return;
        let data;
        try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
        const cards = Array.from(grid.children).filter(card => card.matches('.r32-card[data-r32-product-id]'));
        if (data.pages !== 1 || data.currentPage !== 1) {
          if (data.labels && data.labels.multiplePages) fallback.textContent = data.labels.multiplePages;
          return;
        }
        if (!Array.isArray(data.items) || !data.labels || data.total < 1 || cards.length !== data.total || data.items.length !== data.total || cards.some(card => card.hidden)) return;
        const records = new Map(data.items.map(item => [String(item.id), item]));
        if (records.size !== data.total || new Set(cards.map(card => card.dataset.r32ProductId)).size !== data.total || cards.some(card => !records.has(card.dataset.r32ProductId))) return;
        this.labels = data.labels;
        this.nativeCount = catalog.querySelector('.r32-catalog-top > strong');
        this.nativeCountText = this.nativeCount ? this.nativeCount.textContent : '';
        this.rows = cards.map(card => {
          const record = records.get(card.dataset.r32ProductId);
          return {
            card,
            kind: ['wheel_tire_set', 'tires_only'].includes(record.kind) ? record.kind : 'unknown',
            size: /^\d+(?:\.\d+)?(?:\/\d+(?:\.\d+)?)*$/.test(record.size || '') ? record.size : 'unknown',
            quantity: ['2', '4'].includes(record.quantity) ? record.quantity : 'unknown'
          };
        });
        this.fields = Array.from(this.querySelectorAll('[data-mm-wheel-field]'));
        this.fields.forEach(field => {
          const key = field.dataset.mmWheelField;
          const values = Array.from(new Set(this.rows.map(row => row[key]))).sort((a, b) => {
            if (a === 'unknown') return 1;
            if (b === 'unknown') return -1;
            return a.localeCompare(b, undefined, { numeric: true });
          });
          field.append(new Option(this.labels.all, ''));
          values.forEach(value => field.append(new Option(this.labelFor(key, value), value)));
          field.addEventListener('change', () => this.apply());
        });
        // Keep a selected refinement through the next native sort submission only.
        // The exact locale path and native query prevent leakage to other results.
        const sort = catalog.querySelector('[data-r32-sort]');
        const querySignature = params => JSON.stringify(Array.from(params.entries())
          .filter(([key, value]) => value !== '' && key !== 'preview_theme_id')
          .sort(([a, av], [b, bv]) => a.localeCompare(b) || av.localeCompare(bv)));
        const pendingAge = pendingSort ? Date.now() - pendingSort.savedAt : -1;
        if (pendingSort && pendingAge >= 0 && pendingAge < 120000 && pendingSort.query === querySignature(new URLSearchParams(location.search))) {
          this.fields.forEach(field => {
            const value = pendingSort.values && pendingSort.values[field.dataset.mmWheelField];
            if (typeof value === 'string' && Array.from(field.options).some(option => option.value === value)) field.value = value;
          });
        }
        if (sort && sort.form) {
          let sortChanged = false;
          sort.addEventListener('change', () => { sortChanged = true; }, { capture: true });
          sort.form.addEventListener('submit', event => {
            if (!sortChanged) return;
            sortChanged = false;
            if (event.defaultPrevented) return;
            try {
              sessionStorage.setItem(sortStateKey, JSON.stringify({
                query: querySignature(new URLSearchParams(new FormData(sort.form))),
                savedAt: Date.now(),
                values: Object.fromEntries(this.fields.map(field => [field.dataset.mmWheelField, field.value]))
              }));
            } catch (_) { /* Native sorting remains available without storage. */ }
          });
        }
        this.querySelector('[data-mm-wheel-clear]').addEventListener('click', () => {
          this.fields.forEach(field => { field.value = ''; });
          this.apply();
        });
        this.querySelector('[data-mm-wheel-unknown]').hidden = !this.rows.some(row => [row.kind, row.size, row.quantity].includes('unknown'));
        this.querySelector('[data-mm-wheel-controls]').hidden = false;
        fallback.hidden = true;
        this.ready = true;
        this.apply();
      }

      labelFor(key, value) {
        if (value === 'unknown') return this.labels.unknown;
        if (key === 'kind') return this.labels[value];
        if (key === 'quantity') return value === '2' ? this.labels.pair : this.labels.set_four;
        const sizes = value.split('/').map(size => `${size} mm`).join(' / ');
        return value.includes('/') ? `${sizes} (${this.labels.staggered})` : sizes;
      }

      apply() {
        const selected = Object.fromEntries(this.fields.map(field => [field.dataset.mmWheelField, field.value]));
        const matches = (row, except) => Object.entries(selected).every(([key, value]) => key === except || !value || row[key] === value);
        let count = 0;
        this.rows.forEach(row => {
          const visible = matches(row);
          if (visible) {
            count += 1;
            if (row.card.hasAttribute('data-mm-wheel-hidden')) {
              row.card.removeAttribute('data-mm-wheel-hidden');
              row.card.hidden = false;
            }
          } else {
            row.card.setAttribute('data-mm-wheel-hidden', '');
            row.card.hidden = true;
          }
        });
        this.fields.forEach(field => {
          const key = field.dataset.mmWheelField;
          Array.from(field.options).forEach(option => {
            if (!option.value) return;
            const optionCount = this.rows.filter(row => matches(row, key) && row[key] === option.value).length;
            option.textContent = `${this.labelFor(key, option.value)} (${optionCount})`;
            option.disabled = optionCount === 0 && option.value !== field.value;
          });
        });
        const message = this.labels.status.replace('[count]', String(count)).replace('[total]', String(this.rows.length));
        this.querySelector('[data-mm-wheel-status]').textContent = message;
        if (this.nativeCount) this.nativeCount.textContent = Object.values(selected).some(Boolean) ? message : this.nativeCountText;
        const hasSelection = Object.values(selected).some(Boolean);
        const emptyMessage = this.querySelector('[data-mm-wheel-empty]');
        emptyMessage.textContent = this.labels.noMatches;
        emptyMessage.hidden = count !== 0 || !hasSelection;
      }
    }
    customElements.define('mm-wheel-shopping-filters', MMWheelShoppingFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-year-list-tools"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const VERSION = '1.1.0';
  const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const interpolate = (pattern, values) => Object.entries(values).reduce((text, entry) => text.split('__' + entry[0] + '__').join(String(entry[1])), pattern || '');
  const cellValue = (cell) => cell.hasAttribute('data-mm-value') ? cell.getAttribute('data-mm-value') : cell.textContent.replace(/\s+/g, ' ').trim();
  const csvCell = (value) => {
    let text = String(value ?? '');
    if (/^[\s\uFEFF]*[=+@-]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  const csvDocument = (rows) => '\uFEFF' + rows.map((row) => row.map(csvCell).join(',')).join('\r\n') + '\r\n';
  const matches = (record, query, series, feature) => {
    if (series && record.series !== series) return false;
    if (feature && !record.features.includes(feature)) return false;
    const exactNumber = query.trim().match(/^#\s*(\d+)$/);
    if (exactNumber) {
      const number = String(record.number ?? '').match(/^#?\s*(\d+)(?:\s*\/\s*\d+)?$/);
      return number !== null && Number(number[1]) === Number(exactNumber[1]);
    }
    return normalize(query).split(' ').filter(Boolean).every((token) => record.search.includes(token));
  };

  if (typeof module === 'object' && module.exports) module.exports = { normalize, interpolate, csvCell, csvDocument, matches };
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.MMYearListTools) {
    window.MMYearListTools.mountAll(document);
    return;
  }

  function metadata(root, toolbar) {
    return [
      [toolbar.dataset.mmYearLabel, root.dataset.mmYear || ''],
      [toolbar.dataset.mmScopeLabel, root.dataset.mmScope || ''],
      [toolbar.dataset.mmRevisionLabel, root.dataset.mmRevision || ''],
      [toolbar.dataset.mmSourceLabel, root.dataset.mmCanonical || window.location.href.split('?')[0].split('#')[0]]
    ];
  }

  function printSnapshot(root, toolbar, headers, records, total, locale) {
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.dataset.mmYearPrintFrame = 'true';
    frame.style.cssText = 'position:fixed;width:1px;height:1px;bottom:0;left:-10000px;border:0;';
    document.body.appendChild(frame);
    const printDocument = frame.contentDocument;
    if (!printDocument || !frame.contentWindow) { frame.remove(); throw new Error('Print unavailable'); }
    printDocument.documentElement.lang = locale;
    const title = interpolate(toolbar.dataset.mmPrintTitle, { year: root.dataset.mmYear || '' });
    printDocument.title = title;
    const style = printDocument.createElement('style');
    style.textContent = '@page{size:landscape;margin:12mm}body{font:11px/1.45 Arial,sans-serif;color:#152536;background:white}h1{font-size:20px;margin:0 0 8px}p{margin:3px 0;overflow-wrap:anywhere}table{width:100%;border-collapse:collapse;margin-top:16px;table-layout:auto}th,td{border:1px solid #bac7d0;padding:5px;text-align:left;vertical-align:top;overflow-wrap:anywhere}th{background:#eef3f6}thead{display:table-header-group}tr{break-inside:avoid}';
    printDocument.head.appendChild(style);
    const heading = printDocument.createElement('h1');
    heading.textContent = title;
    printDocument.body.appendChild(heading);
    metadata(root, toolbar).forEach(([label, value]) => {
      if (!value) return;
      const line = printDocument.createElement('p');
      line.textContent = label + ': ' + value;
      printDocument.body.appendChild(line);
    });
    const count = printDocument.createElement('p');
    count.textContent = interpolate(toolbar.dataset.mmPrintCount, { shown: records.length, total });
    printDocument.body.appendChild(count);
    const table = printDocument.createElement('table');
    const head = table.createTHead().insertRow();
    headers.forEach((header) => {
      const th = printDocument.createElement('th');
      th.scope = 'col';
      th.textContent = header.label;
      head.appendChild(th);
    });
    const body = table.createTBody();
    records.forEach((record) => {
      const row = body.insertRow();
      record.values.forEach((value) => { row.insertCell().textContent = value; });
    });
    printDocument.body.appendChild(table);
    const cleanup = () => { if (frame.isConnected) frame.remove(); };
    frame.contentWindow.addEventListener('afterprint', cleanup, { once: true });
    window.setTimeout(cleanup, 300000);
    window.requestAnimationFrame(() => {
      try { frame.contentWindow.focus(); frame.contentWindow.print(); }
      catch (error) { cleanup(); showError(toolbar); }
    });
  }

  function showError(toolbar) {
    const output = toolbar.querySelector('[data-mm-year-error]');
    output.textContent = toolbar.dataset.mmOutputError;
    output.hidden = false;
  }

  function mount(root, template) {
    if (root.dataset.mmYearReady === 'true' || root.querySelector('[data-mm-year-toolbar]')) return;
    const tables = Array.from(root.querySelectorAll('table[data-mm-year-table]')).filter((table) => table.closest('[data-mm-year-list]') === root);
    const table = tables[0];
    if (!table || !table.tHead || !table.tHead.rows.length || !table.tBodies.length) return;
    const headings = Array.from(table.tHead.rows[0].cells);
    if (!headings.length || headings.some((cell) => !cell.dataset.mmField)) return;
    const headers = headings.map((cell) => ({ field: cell.dataset.mmField, label: cellValue(cell) }));
    if (new Set(headers.map((header) => header.field)).size !== headers.length) return;
    const compatibleTables = tables.every((candidate) => {
      if (!candidate.tHead || !candidate.tHead.rows.length || !candidate.tBodies.length) return false;
      const cells = Array.from(candidate.tHead.rows[0].cells);
      return cells.length === headers.length && cells.every((cell, index) => cell.dataset.mmField === headers[index].field && cell.colSpan === 1 && cell.rowSpan === 1);
    });
    if (!compatibleTables) return;
    const rows = tables.flatMap((candidate) => Array.from(candidate.tBodies).flatMap((body) => Array.from(body.rows)));
    if (!rows.length || rows.some((row) => row.cells.length !== headers.length || Array.from(row.cells).some((cell) => cell.colSpan !== 1 || cell.rowSpan !== 1))) return;
    const records = rows.map((row) => {
      const values = Array.from(row.cells).map(cellValue);
      const fields = Object.fromEntries(headers.map((header, index) => [header.field, values[index]]));
      return {
        row,
        values,
        id: row.dataset.mmRowId || '',
        series: row.dataset.mmSeries || fields.series || '',
        features: (row.dataset.mmTypes || '').toLowerCase().split(/\s+/).filter(Boolean),
        number: (fields.number || '').trim(),
        search: normalize(values.join(' ') + ' ' + (row.dataset.mmSearch || ''))
      };
    });
    const toolbar = template.content.querySelector('[data-mm-year-toolbar]').cloneNode(true);
    const wrapper = table.closest('[data-mm-year-table-region]');
    const region = wrapper && wrapper !== root && root.contains(wrapper) ? wrapper : table;
    region.parentNode.insertBefore(toolbar, region);
    const search = toolbar.querySelector('[data-mm-year-search]');
    const series = toolbar.querySelector('[data-mm-year-series]');
    const feature = toolbar.querySelector('[data-mm-year-feature]');
    const locale = template.dataset.mmYearLocale || document.documentElement.lang || 'en';
    const knownSeries = Array.from(new Set(records.map((record) => record.series).filter(Boolean))).sort((a, b) => a.localeCompare(b, locale));
    knownSeries.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      series.appendChild(option);
    });
    toolbar.querySelector('[data-mm-year-series-wrap]').hidden = knownSeries.length < 2;
    const knownFeatures = new Set(records.flatMap((record) => record.features));
    Array.from(feature.options).forEach((option) => { if (option.value && !knownFeatures.has(option.value)) option.remove(); });
    toolbar.querySelector('[data-mm-year-feature-wrap]').hidden = feature.options.length < 2;
    const status = toolbar.querySelector('[data-mm-year-status]');
    const empty = toolbar.querySelector('[data-mm-year-empty]');
    const filteredButtons = toolbar.querySelectorAll('[data-mm-year-csv="filtered"], [data-mm-year-print="filtered"]');
    let visible = records;
    const apply = () => {
      visible = records.filter((record) => matches(record, search.value, series.value, feature.value));
      const visibleSet = new Set(visible);
      records.forEach((record) => { record.row.hidden = !visibleSet.has(record); });
      status.textContent = interpolate(toolbar.dataset.mmCountPattern, { shown: visible.length, total: records.length });
      empty.hidden = visible.length !== 0;
      filteredButtons.forEach((button) => { button.disabled = visible.length === 0; });
      toolbar.querySelector('[data-mm-year-error]').hidden = true;
    };
    search.addEventListener('input', apply);
    series.addEventListener('change', apply);
    feature.addEventListener('change', apply);
    toolbar.querySelector('[data-mm-year-reset]').addEventListener('click', () => {
      search.value = '';
      series.value = '';
      feature.value = '';
      apply();
      search.focus();
    });
    toolbar.querySelectorAll('[data-mm-year-csv]').forEach((button) => {
      button.addEventListener('click', () => {
        try {
          const selected = button.dataset.mmYearCsv === 'all' ? records : visible;
          const meta = metadata(root, toolbar);
          const exportRows = [meta.map((pair) => pair[0]).concat(toolbar.dataset.mmEntryIdLabel, headers.map((header) => header.label))];
          selected.forEach((record) => { exportRows.push(meta.map((pair) => pair[1]).concat(record.id, record.values)); });
          const blob = new Blob([csvDocument(exportRows)], { type: 'text/csv;charset=utf-8' });
          const url = URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = 'hot-wheels-' + (root.dataset.mmYear || 'list') + '-' + locale + '-' + button.dataset.mmYearCsv + '.csv';
          anchor.hidden = true;
          root.appendChild(anchor);
          anchor.click();
          anchor.remove();
          window.setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (error) { showError(toolbar); }
      });
    });
    toolbar.querySelectorAll('[data-mm-year-print]').forEach((button) => {
      button.addEventListener('click', () => {
        try { printSnapshot(root, toolbar, headers, button.dataset.mmYearPrint === 'all' ? records : visible, records.length, locale); }
        catch (error) { showError(toolbar); }
      });
    });
    root.dataset.mmYearReady = 'true';
    apply();
  }

  function mountAll(context) {
    const templates = Array.from(context.querySelectorAll('template[data-mm-year-tools-template]'));
    templates.forEach((template) => {
      const target = template.dataset.mmYearTarget;
      const roots = Array.from(document.querySelectorAll('[data-mm-year-list]'));
      const root = template.closest('[data-mm-year-list]') || roots.find((candidate) => candidate.dataset.mmPageId === target) || (roots.length === 1 ? roots[0] : null);
      if (!root) return;
      try { mount(root, template); }
      catch (error) {
        root.querySelectorAll('[data-mm-year-table] tbody tr').forEach((row) => { row.hidden = false; });
        root.querySelectorAll('[data-mm-year-toolbar]').forEach((toolbar) => toolbar.remove());
        delete root.dataset.mmYearReady;
      }
    });
  }

  window.MMYearListTools = { version: VERSION, mountAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(document), { once: true });
  else mountAll(document);
  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
}());
  } catch(e) { console.error(e); }
})();

})();
